module.exports = __webpack_public_path__ + "img/ROBOTARM_MV.1e7fda30.png";